// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ImagesCopyIconSignature {
  Element: SVGSVGElement;
}

export const ImagesCopyIcon: TOC<ImagesCopyIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 21.001H20C20.553 21.001 21 20.553 21 20.001V4.00101C21 3.44901 20.553 3.00101 20 3.00101H4C3.447 3.00101 3 3.44901 3 4.00101V20.001C3 20.553 3.447 21.001 4 21.001ZM19 19.001H5V5.00101H19V19.001ZM14 11.001L11.412 14.883L10 13.001L7 17.001H17L14 11.001ZM10.4142 10.4152C11.1952 9.63418 11.1952 8.36785 10.4142 7.5868C9.63315 6.80575 8.36682 6.80575 7.58577 7.5868C6.80472 8.36785 6.80472 9.63418 7.58577 10.4152C8.36682 11.1963 9.63315 11.1963 10.4142 10.4152Z"/>
</svg>
</template>;